module.exports = __webpack_public_path__ + "img/1.6dc65b8f.png";